import {VerticalDivider} from "@/components/VerticalDivider.tsx";
import {TagsBulkActionDelete} from "@/pages/tags/list/TagsBulkActionDelete.tsx";

export interface TagsBulkActionBarProps {
  selectedIds: number[];
  onSuccess: () => void;
}

export const TagsBulkActionBar = ({selectedIds, onSuccess}: TagsBulkActionBarProps) => {
  return <TagsBulkActionDelete selectedItemsIds={selectedIds} onSuccess={onSuccess} />;
  return (
    <div className="d-flex bulk-action-bar ps-2">
      <div className="fs-7 fw-semibold align-self-center text-end m-2" style={{width: "5.6rem"}}>
        {Object.keys(selectedIds).length} Selected
      </div>

      {selectedIds.length > 0 && (
        <>
          <VerticalDivider />
          <TagsBulkActionDelete selectedItemsIds={selectedIds} onSuccess={onSuccess} />
        </>
      )}
    </div>
  );
};
